import { latestArchives, type ArchiveCard } from '@/mocks/homeData';

const toneMap: Record<ArchiveCard['tagTone'], string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function LatestArchives() {
  return (
    <section id="archive" className="w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-primary-600">LATEST · 最新入档</p>
            <h3 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">
              今日归档 · 新料实时入档备查
            </h3>
          </div>
          <a
            href="#flash"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-foreground-950"
          >
            进入快讯流
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {latestArchives.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] font-medium text-foreground-400">{a.no}</span>
                <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${toneMap[a.tagTone]}`}>
                  {a.tag}
                </span>
              </div>

              <h4 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                <a href="#digest">{a.title}</a>
              </h4>

              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.brief}</p>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {a.time}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true"></i>
                  {a.views}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}